import axios from "axios";
import { hostUrl } from "../utils/constant";
import { MOCK_DADA, anyVoid } from "../service/test_api.js";

const searchStr = location.search;
const params = new URLSearchParams(searchStr);

const mock = !!params.get("mock"); // is the bo
const baseURL = "/";
const contentType = "application/json";
axios.defaults.withCredentials = true;
// axios.defaults.headers = {
//   "X-Requested-With": 'XMLHttpRequest'
// };

// 最长请求时间
const requestTimeout = 20000;
// 协议成功状态码
const successCode = [200, "200", 0];
const NoauthCode = [1042];

// 联运分级分权错误码
const PERMISSION_ERROR_CODES = {
  NO_MODULE_PERMISSION: 10013,
  IDENTITY_NOT_SELECTED: 10500,
  IDENTITY_INVALID: 10501,
};

const getHeaders = () => {
  return {
    "x-csrf-token": getCookie("csrfToken"), // 兼容后端按 cookie 校验的场景，直接读取 csrfToken
  };
};

// 封装获取 cookie 的方法
function getCookie(name) {
  let arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  return null;
}

const handleResponse = function(response) {
  const { data, status, config } = response;
  console.log(data, status, config);

  // blob 响应跳过业务错误码处理，由调用方自行处理
  if (config && config.__skipInterceptor) {
    return Promise.resolve(response);
  }

  const code = data.errno;

  // 未登录或登录状态已失效
  if (NoauthCode.includes(code)) {
    EE.emit("logout", {
      from: code,
      response,
    });
  }

  // 联运分级分权：多身份未选择 → 跳转身份选择页
  // 注意：若当前已在身份选择页，避免再次 href 触发整页重复刷新
  if (code === PERMISSION_ERROR_CODES.IDENTITY_NOT_SELECTED) {
    if (window.location.pathname !== "/view/identity_select") {
      window.location.href = "/view/identity_select";
    }
    return Promise.reject(data);
  }

  // 联运分级分权：身份已失效/被移除 → 跳转无权限页
  // 同理：若已在 no_access 页，不重复整页跳转
  if (code === PERMISSION_ERROR_CODES.IDENTITY_INVALID) {
    if (window.location.pathname !== "/view/no_access") {
      window.location.href = "/view/no_access?scene=identity_invalid";
    }
    return Promise.reject(data);
  }

  // 联运分级分权：无模块权限 → 不跳转，由页面组件处理展示
  if (code === PERMISSION_ERROR_CODES.NO_MODULE_PERMISSION) {
    try {
      const store = require("../models/store").default;
      store.dispatch.permission.setState({ pagePermissionDenied: true });
      store.dispatch.permission.refreshAccessInfoAsync().catch(() => {});
    } catch (_e) { /* 静默 */ }
    return Promise.reject(data);
  }

  switch (code) {
    case 0:
      return Promise.resolve(data?.data);
  }

  return Promise.reject(data);
};

const service = axios.create({
  baseURL: hostUrl,
  // headers: {
  //   ...getHeaders(),
  // },
  timeout: requestTimeout,
  withCredentials: true, // 默认携带 cookie，如 ajax 请求第三方接口/CDN，请注意指定 withCredentials false
});

// axios.get('https://sim-api.openstore.360.cn/main/plat/v1/access/getinfo', {
//   headers: {
//     'Content-Type': "application/json"
//   },
//   withCredentials: true
// })

// service.get('/main/plat/v1/access/getinfo', {
//   // headers: {
//   //   'Content-Type': "application/json"
//   // },
//   // withCredentials: true
// })

// API Request 格式:Form Data
service.interceptors.request.use(
  (request) => {
    if (request.method == "get") {
      request.data = true;
    }
    // request.headers = getHeaders();
    console.log("request.headers is", request.headers);
    return request;
  },
  (error) => {
    return Promise.reject(new Error(error));
  }
);

service.interceptors.response.use(
  (response) => {
    return handleResponse(response);
  },
  (error) => {
    
    console.log("error", error);

    const { response, message, config } = error;
    if (axios.isCancel(error)) {
      return Promise.reject({
        errno: -2,
        errmsg: "请求取消",
        url: error.config.url,
        error: {
          code: error.code,
          name: error.name,
          message: error.message,
        },
      });
    } else if (response === undefined) {
      if (message && message.includes) {
        if (message.includes("timeout")) {
          return Promise.reject({
            errno: -1,
            errmsg: "请求超时",
            url: error.config.url,
            error: {
              code: error.code,
              name: error.name,
              message: error.message,
            },
          });
        }
      }
      return Promise.reject(error);
    } 
    return handleResponse(response);
    
  }
);

// service.get('/main/plat/v1/access/getinfo', {
//   headers: {
//     'Content-Type': "application/json"
//   },
//   withCredentials: true
// })

// export const userLogOut = function() {
//   return service.get(`main/plat/v1/access/logout`);
// };

// // 获取用户频道信息
// export const getUserInfo = function() {
//   return service.get('main/plat/v1/access/getinfo');
// };

export default service;
